module.exports = __webpack_public_path__ + "img/info_icon2.109a81a2.svg";